import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';

@Component({
  selector: 'app-unity-detail',
  templateUrl: './unity-detail.component.html',
  styleUrls: ['./unity-detail.component.css']
})
export class UnityDetailComponent implements OnInit {
  unity = new Unity();
  loading:boolean = false;
  @ViewChild('unityDetailModal') m;

  constructor(private modal:NgbModal, private unityServ:UnityService) { }

  ngOnInit() {
  }

  open(unity:Unity|number) {
    if (typeof unity === 'number') {
      this.loading = true;
      this.unityServ.getUnity(unity)
        .then(u => {
          this.unity = u;
          this.modal.open(this.m);
          this.loading = false;
        });
    } else {
      this.unity = unity;
      this.modal.open(this.m);
    }
  }
}
